export default function instagramCard({main, elm, state, publish}) {
	main(_ => {
		elm.addEventListener('click', open);
	});

	const open = function () {
		const item = state.get();

		publish('instagram:open', item);
	};
};

export const model = {};
